document.addEventListener('DOMContentLoaded', () => {
    const splide = new Splide('#video-testmonials', {
        type: 'loop',
        perPage: 5,
        autoplay: true,
        perMove: 1,
        interval: 2000,
        pauseOnHover: true,
        pauseOnFocus: true,
        arrows: false,
        fixedHeight: '380px',
        pagination: true,
        gap: "16px",
        breakpoints: {
            768: {
                perPage: 2,
            },
            992: {
                perPage: 3,
            },
        }
    }).mount();
})